<template>
  <div class="RoundExtraInfo">
    <underlined-heading :color="titleColor">{{ title }}</underlined-heading>
    <div class="text-sm font-light">
      <div
        v-for="feat in content"
        :key="feat"
        class="mb-2"
      >
        {{ feat }}
      </div>
    </div>
  </div>
</template>

<script>
import UnderlinedHeading from '@/components/core/UnderlinedHeading'

/**
 * @module RoundExtraInfo
 */
export default {
  name: 'RoundExtraInfo',
  components: { UnderlinedHeading },
  props: {
    titleColor: {
      type: String,
      default: 'dark-red'
    },
    title: {
      type: String,
      default: ''
    },
    content: {
      type: Array,
      default: () => []
    }
  }
}
</script>

<style lang='scss'>
@import '~utils';

</style>
